module.exports = "/assets/data/273779d54d23506e3472a957f82c2460-KA21.data.json";